// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.streams-drawer-grid-item {
  width: 232px;
}
.streams-drawer-grid-item .grid-item-image-wrapper {
  background-color: #f5f6f6;
  height: 232px;
}
.streams-drawer-grid-item .grid-item-image-wrapper .info-icon {
  color: #fff;
  right: 8px;
  top: 8px;
}
.streams-drawer-grid-item .grid-item-image-wrapper .info-icon cu-icon {
  display: none;
}
.streams-drawer-grid-item .grid-item-image-wrapper:hover .info-icon cu-icon,
.streams-drawer-grid-item .grid-item-image-wrapper .info-icon .cu-popover-opened cu-icon {
  display: inline-block;
}
.streams-grid-info-tooltip-content {
  max-height: 232px;
  max-width: 232px;
  overflow-y: scroll;
}
`, "",{"version":3,"sources":["webpack://./app/streams-drawer/streams-drawer-content/streams-drawer-grid-item/streams-drawer-grid-item.less"],"names":[],"mappings":"AAEA;EACE,YAAA;AADF;AAAA;EAII,yBAAA;EACA,aAAA;AADJ;AAJA;EAQM,WAAA;EACA,UAAA;EACA,QAAA;AADN;AATA;EAYQ,aAAA;AAAR;AAMI;;EAEE,qBAAA;AAJN;AASA;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;AAPF","sourcesContent":["@import (reference) '../../../../css/unison';\n\n.streams-drawer-grid-item {\n  width: @cu-small-measure;\n\n  .grid-item-image-wrapper {\n    background-color: @cu-gray-0;\n    height: @cu-small-measure;\n\n    .info-icon {\n      color: @cu-white;\n      right: 8px;\n      top: 8px;\n      cu-icon {\n        display: none;\n      }\n    }\n\n    // Icon is visible when hovering on the grid item,\n    // or while its tooltip is open.\n    &:hover .info-icon cu-icon,\n    .info-icon .cu-popover-opened cu-icon {\n      display: inline-block;\n    }\n  }\n}\n\n.streams-grid-info-tooltip-content {\n  max-height: @cu-small-measure;\n  max-width: @cu-small-measure;\n  overflow-y: scroll;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
